/**
 * @file
 * @description 过滤器插件
 */

import {matchOfficialProcess, limitMaxNum} from '@/utils/matchFilter';

export const filterPlugin = Vue => {
    Vue.filter('limitMaxNum', limitMaxNum);
    Vue.filter('matchOfficialProcess', matchOfficialProcess);
};
